import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { NavLink } from 'reactstrap'
import { setApplicationDetailRoute } from 'store/Recruitment/actions'
import { APPLICATION_DETAIL_RATING } from 'store/Recruitment/reducer'
import { APPLICATION_DETAIL_TODO } from 'store/Recruitment/reducer'
import { APPLICATION_DETAIL_NOTES } from 'store/Recruitment/reducer'
import { APPLICATION_DETAIL_INTERVIEW } from 'store/Recruitment/reducer'
import { APPLICATION_DETAIL_DETAILS } from 'store/Recruitment/reducer'
import Details from './Details'
import Interview from './Interview'
import Rating from './Rating'
import Notes from './Notes'
import Todo from './Todo'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { getApplication } from 'store/Recruitment/actions'

function ApplicationDetails({ onDeleteFn }) {
  const dispatch = useDispatch()
  const location = useLocation()

  const { currentApplicationDetailRoute } = useSelector(
    (store) => store.recruitment
  )

  useEffect(() => {
    dispatch(getApplication(location?.search?.split('=')?.at(1)))
  }, [location?.search, dispatch])

  useEffect(() => {
    return () => {
      dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_DETAILS))
    }
  }, [dispatch])

  return (
    <div>
      <div className='settings-tabs dFlex md-flexCol textCenter gap-10 py-1 current border ml-auto'>
        <NavLink
          onClick={() =>
            dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_DETAILS))
          }
          className={`${
            currentApplicationDetailRoute === APPLICATION_DETAIL_DETAILS
              ? 'current'
              : ''
          }`}
        >
          Details
        </NavLink>
        <NavLink
          onClick={() =>
            dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_INTERVIEW))
          }
          className={`${
            currentApplicationDetailRoute === APPLICATION_DETAIL_INTERVIEW
              ? 'current'
              : ''
          }`}
        >
          Interview
        </NavLink>
        <NavLink
          onClick={() =>
            dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_RATING))
          }
          className={`${
            currentApplicationDetailRoute === APPLICATION_DETAIL_RATING
              ? 'current'
              : ''
          }`}
        >
          Rating
        </NavLink>
        <NavLink
          onClick={() =>
            dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_NOTES))
          }
          className={`${
            currentApplicationDetailRoute === APPLICATION_DETAIL_NOTES
              ? 'current'
              : ''
          }`}
        >
          Notes
        </NavLink>
        <NavLink
          onClick={() =>
            dispatch(setApplicationDetailRoute(APPLICATION_DETAIL_TODO))
          }
          className={`${
            currentApplicationDetailRoute === APPLICATION_DETAIL_TODO
              ? 'current'
              : ''
          }`}
        >
          To Do
        </NavLink>
      </div>

      {currentApplicationDetailRoute === APPLICATION_DETAIL_DETAILS && (
        <Details onDeleteFn={onDeleteFn} />
      )}
      {currentApplicationDetailRoute === APPLICATION_DETAIL_INTERVIEW && (
        <Interview />
      )}
      {currentApplicationDetailRoute === APPLICATION_DETAIL_RATING && (
        <Rating />
      )}
      {currentApplicationDetailRoute === APPLICATION_DETAIL_NOTES && <Notes />}
      {currentApplicationDetailRoute === APPLICATION_DETAIL_TODO && <Todo />}
    </div>
  )
}

export default ApplicationDetails
